import { useContext } from 'react';

import {
  useMutation as useMutationOriginal,
  useQueryClient,
} from '@tanstack/react-query';

import MessageContext from './MessageContext';
import { matchQuery } from './utils';

const defaultErrorMessage = (error: any) => {
  return typeof error === 'string' ? error : error?.message || error?.messages;
};
//
// const willQueryBeRefreshed = (
//   mutationKey: any,
//   queryKey: any,
//   resfreshKey: any
// ) => {
//   switch (resfreshKey) {
//     case "all":
//       return true;
//     case "same":
//       return mutationKey[0].includes(
//         Array.isArray(queryKey) ? queryKey[0] : queryKey
//       );
//     case "notSame":
//       return !mutationKey[0].includes(
//         Array.isArray(queryKey) ? queryKey[0] : queryKey
//       );
//     default:
//       return false;
//   }
// };

export const useMutation = (
  mutationKey: any,
  mutationFn: any,
  {
    refresh = false,
    refreshOptions = {
      //'same', 'notSame','all'
      refreshKey: 'same',
    },
    errorMessage = defaultErrorMessage,
    successMessage,
    onError,
    onSuccess,
    ...options
  }: any = {}
) => {
  const { showErrorMessage, showSuccessMessage } = useContext(MessageContext);

  const queryClient = useQueryClient();

  const { refreshKey = 'same' } = refreshOptions;

  return useMutationOriginal(mutationKey, mutationFn, {
    ...options,
    onError: (error: any, variables: any, context: any) => {
      if (errorMessage) {
        const message = errorMessage(error, variables, context);
        showErrorMessage(message);
      }

      return onError?.(error, variables, context);
    },
    onSuccess: (data: any, variables: any, context: any) => {
      if (successMessage) {
        const message = successMessage(data, variables, context);

        if (message) {
          showSuccessMessage(message);
        }
      }

      if (refresh) {
        const {
          withoutQueryKey: withoutQueryKeyOption,
          ...refreshOptionsOther
        } = refreshOptions;
        const params = { active: true, ...refreshOptionsOther };

        params.predicate = (query: any) => {
          return matchQuery(
            {
              refreshKey: refreshKey,
              mutationKey,
              queryKey: refreshOptions.queryKey,
              exact: false,
            },
            query
          );
        };

        if (typeof withoutQueryKeyOption === 'function') {
          const withoutQueryKey = withoutQueryKeyOption(variables);
          params.predicate = (query: any) => {
            return !matchQuery({ queryKey: withoutQueryKey }, query);
          };

          if (refreshOptionsOther.predicate) {
            throw new Error('Predicate conflict with "withoutQueryKey"');
          }
        }

        if (typeof refreshOptionsOther.queryKey === 'function') {
          refreshOptionsOther.queryKey =
            refreshOptionsOther.queryKey(variables);
        }
        queryClient.resetQueries(params);
      }

      return onSuccess?.(data, variables, context);
    },
  });
};
